import { render, staticRenderFns } from "./supplementar.mpx?vue&type=template&id=715673a0&scoped=true&component=true&componentId=supplementar010d8998"
import script from "./supplementar.mpx?vue&type=script&lang=js&component=true&componentId=supplementar010d8998"
export * from "./supplementar.mpx?vue&type=script&lang=js&component=true&componentId=supplementar010d8998"
import style0 from "./supplementar.mpx?vue&type=style&index=0&id=715673a0&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m010d8998%22%7D&component=true&componentId=supplementar010d8998"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715673a0",
  null
  
)

export default component.exports